<template>
  <div class="home-data" :class="[deviceType]">
    <!-- 标题部分 -->
    <div class="data-header">
      <div class="data-dot"></div>
      <div class="data-title">Data Overview</div>
    </div>

    <!-- 数据卡片部分 -->
    <div class="data-cards">
      <!-- 总名字数量卡片 -->
      <div class="data-card total-names">
        <div class="card-header">
          <div class="card-title light">Total Number of Names</div>
          <router-link to="/names" tag="div" class="see-more">
            <span class="light">See More</span>
            <img src="@/assets/default/arrow-right-small_w.svg" alt="arrow" />
          </router-link>
        </div>
        <div class="card-description">
          There are over {{ totalNames }} unique {{ nameOrigin }} names in our collection.
        </div>
        <div class="number-counter">
          <div class="digit-container" v-for="(digit, index) in totalNamesDigits" :key="index">
            <div class="digit-flipper" :data-digit="digit">
              <div class="digit-top"></div>
              <div class="digit-bottom"></div>
              <div class="digit-number">{{ digit }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 性别比例卡片 -->
      <div class="data-card gender-ratio">
        <div class="card-header" v-if="deviceType == 'mobile'">
          <div class="card-title">Gender Ratio</div>
          <router-link to="/categories/gender" tag="div" class="see-more">
            <span>See More</span>
            <img src="@/assets/default/arrow-right-small.svg" alt="arrow" />
          </router-link>
        </div>
        <div class="gender-content">

          <div class="gender-legend">
            <div class="card-header">
              <div class="card-title">Gender Ratio</div>
            </div>
            <div class="legend-item">
              <div class="legend-color boy"></div>
              <div class="legend-text">Boy</div>
            </div>
            <div class="legend-item">
              <div class="legend-color girl"></div>
              <div class="legend-text">Girl</div>
            </div>
            <div class="legend-item">
              <div class="legend-color unisex"></div>
              <div class="legend-text">Unisex</div>
            </div>
          </div>
          <div class="gender-chart" ref="genderChart">
            <!-- 饼图将在这里渲染 -->
          </div>
        </div>
        <div class="card-footer">
          <div class="footer-text">
            {{ nameOrigin }} names are mostly {{ mainGender }} names.
          </div>
          <router-link to="/categories/gender" tag="div" class="see-more"
            v-if="deviceType !== 'mobile'">
            <span>See More</span>
            <img src="@/assets/default/arrow-right-small.svg" alt="arrow" />
          </router-link>
        </div>
      </div>

      <!-- 风格分布卡片 -->
      <div class="data-card style-distribution">
        <div class="card-header">
          <div class="card-title">Style Distribution</div>
          <router-link to="/categories/style" tag="div" class="see-more"
            v-if="deviceType == 'mobile'">
            <span>See More</span>
            <img src="@/assets/default/arrow-right-small.svg" alt="arrow" />
          </router-link>
        </div>
        <div class="style-chart">
          <div class="style-item" v-for="(style, index) in styles" :key="index">
            <div class="style-bar" :style="{ height: style.height + '%' }"></div>
            <div class="style-label">{{ style.name }}</div>
          </div>
        </div>
        <div class="card-footer">
          <div class="footer-text">
            {{ popularStyles }} styles are the most common in {{ nameOrigin }} names.
          </div>
          <router-link to="/categories/style" tag="div" class="see-more"
            v-if="deviceType != 'mobile'">
            <span>See More</span>
            <img src="@/assets/default/arrow-right-small.svg" alt="arrow" />
          </router-link>
        </div>
      </div>

      <!-- 音节分布卡片 -->
      <div class="data-card syllable-distribution">
        <div class="card-header">
          <div class="card-title">Syllable Distribution</div>
          <router-link to="/categories/syllables" tag="div" class="see-more"
            v-if="deviceType == 'mobile'">
            <span>See More</span>
            <img src="@/assets/default/arrow-right-small.svg" alt="arrow" />
          </router-link>
        </div>
        <div class="syllable-chart">
          <div class="syllable-row" v-for="(syllable, index) in syllables" :key="index">
            <div class="syllable-label">{{ syllable.count }}
              Syllable{{ syllable.count > 1 ? 's' : '' }}</div>
            <div class="syllable-bar-container">
              <div class="syllable-bar" :style="{ width: syllable.percentage + '%' }"></div>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="footer-text">
            Most names from {{ nameOrigin }} origin have {{ mainSyllable }}-syllable structures.
          </div>
          <router-link to="/categories/syllables" tag="div" class="see-more"
            v-if="deviceType !== 'mobile'">
            <span>See More</span>
            <img src="@/assets/default/arrow-right-small.svg" alt="arrow" />
          </router-link>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'HomeData',
  data () {
    return {
      overviewData: null
    }
  },
  computed: {
    ...mapGetters([
      'deviceType',
      'domainConfig'
    ]),
    nameOrigin () {
      return this.domainConfig?.origin || 'our';
    },
    totalNames () {
      if (!this.overviewData) return '0';
      return this.overviewData.total.toLocaleString();
    },
    totalNamesDigits () {
      if (!this.overviewData) return ['0'];
      return String(this.overviewData.total).split('');
    },
    genderData () {
      if (!this.overviewData?.genderDistribution) return [];
      const distribution = this.overviewData.genderDistribution;
      const total = Object.values(distribution).reduce((sum, count) => sum + count, 0);
      if (total === 0) return [];

      return [
        { gender: 'Boy', percentage: (distribution.Boy || 0) / total * 100, color: '#38ABFF' },
        { gender: 'Girl', percentage: (distribution.Girl || 0) / total * 100, color: '#E54CBA' },
        { gender: 'Unisex', percentage: (distribution.Unisex || 0) / total * 100, color: '#10AD2F' }
      ];
    },
    mainGender () {
      if (!this.overviewData?.genderDistribution) return '';
      const distribution = this.overviewData.genderDistribution;
      if (!distribution || Object.keys(distribution).length === 0) return '';
      const main = Object.keys(distribution).reduce((a, b) => distribution[a] > distribution[b] ? a : b);
      return main.toLowerCase();
    },
    styles () {
      if (!this.overviewData?.styleDistribution) return [];
      const distribution = this.overviewData.styleDistribution;
      const values = Object.values(distribution);
      if (values.length === 0) return [];
      const maxCount = Math.max(...values);
      if (maxCount === 0) return [];

      return Object.entries(distribution).map(([name, count]) => ({
        name: name,
        height: (count / maxCount) * 100,
      })).slice(0, 10);
    },
    popularStyles () {
      if (!this.overviewData?.styleDistribution) return '';
      const distribution = this.overviewData.styleDistribution;
      const popular = Object.keys(distribution).sort((a, b) => distribution[b] - distribution[a]);
      if (popular.length > 1) {
        return `${popular[0]} and ${popular[1]}`
      } else if (popular.length > 0) {
        return popular.join(' and ');
      }
      return '';
    },
    syllables () {
      if (!this.overviewData?.syllableDistribution) return [];
      const distribution = this.overviewData.syllableDistribution;
      const total = Object.values(distribution).reduce((sum, count) => sum + count, 0);
      if (total === 0) return [];

      return Object.entries(distribution).map(([count, num]) => ({
        count: Number(count),
        percentage: (num / total) * 100,
      }));
    },
    mainSyllable () {
      if (!this.overviewData?.syllableDistribution) return '';
      const distribution = this.overviewData.syllableDistribution;
      if (!distribution || Object.keys(distribution).length === 0) return '';
      return Object.keys(distribution).reduce((a, b) => distribution[a] > distribution[b] ? a : b);
    }
  },
  watch: {
    overviewData (newData) {
      if (newData) {
        this.$nextTick(() => {
          this.initNumberCounter()
          this.initGenderChart()
        });
      }
    }
  },
  mounted () {
    this.fetchNameOverview();
  },
  methods: {
    fetchNameOverview () {
      // 从domainConfig获取origin参数
      const origin = this.domainConfig?.origin || '';

      // 请求/name/overview接口
      return this.$global.server.postAPI({
        method: 'get',
        params: {
          origin: origin
        },
        url: '/name/overview',
      })
        .then(response => {
          if (response && response.data) {
            // 将接口返回存储到vuex
            this.overviewData = response.data;
            console.log('名字概览数据获取成功:', response.data);
          }
          return response;
        })
        .catch(error => {
          console.error('获取名字概览数据失败:', error);
          return Promise.reject(error);
        });
    },
    initNumberCounter () {
      // 延迟执行，确保DOM已渲染
      setTimeout(() => {
        const digitElements = document.querySelectorAll('.digit-flipper')
        digitElements.forEach(element => {
          const digit = element.getAttribute('data-digit')
          element.querySelector('.digit-number').textContent = digit
        })
      }, 100)
    },
    initGenderChart () {
      if (window.google && window.google.charts) {
        this.drawGenderChart()
      } else {
        // 加载Google Charts库
        const script = document.createElement('script')
        script.src = 'https://www.gstatic.com/charts/loader.js'
        script.onload = () => {
          window.google.charts.load('current', { packages: ['corechart'] })
          window.google.charts.setOnLoadCallback(this.drawGenderChart)
        }
        document.head.appendChild(script)
      }
    },
    drawGenderChart () {
      if (!this.$refs.genderChart) return

      try {
        // 如果Google Charts库已加载
        if (window.google && window.google.visualization) {
          const data = new window.google.visualization.DataTable()
          data.addColumn('string', 'Gender')
          data.addColumn('number', 'Percentage')

          this.genderData.forEach(item => {
            data.addRow([item.gender, item.percentage])
          })
          let width, height

          const el = document.querySelector('.gender-chart');
          if (el) {
            const rect = el.getBoundingClientRect();
            width = rect.width;
            height = rect.height;
            console.log('宽度:', width, '高度:', height);
          }

          const options = {
            is3D: true, // 启用3D效果
            pieSliceText: 'percentage', // 显示百分比
            colors: this.genderData.map(item => item.color),
            legend: 'none',
            chartArea: { width: '100%', height: '100%' },
            backgroundColor: 'transparent',
            width: width,
            height: height
          }

          const chart = new window.google.visualization.PieChart(this.$refs.genderChart)
          chart.draw(data, options)
        } else {
          // 如果Google Charts库未加载，使用备用方案
          this.renderFallbackChart()
        }
      } catch (error) {
        console.error('Error drawing chart:', error)
        this.renderFallbackChart()
      }
    },
    renderFallbackChart () {
      if (!this.$refs.genderChart) return

      // 创建简单的CSS饼图作为备用
      const chartElement = this.$refs.genderChart
      chartElement.innerHTML = ''
      chartElement.style.position = 'relative'

      let cumulativePercentage = 0

      this.genderData.forEach(item => {
        const slice = document.createElement('div')
        slice.style.position = 'absolute'
        slice.style.width = '100%'
        slice.style.height = '100%'
        slice.style.borderRadius = '50%'
        slice.style.clip = `rect(0, ${chartElement.clientWidth}px, ${chartElement.clientHeight}px, ${chartElement.clientWidth / 2}px)`

        const innerSlice = document.createElement('div')
        innerSlice.style.position = 'absolute'
        innerSlice.style.width = '100%'
        innerSlice.style.height = '100%'
        innerSlice.style.borderRadius = '50%'
        innerSlice.style.clip = `rect(0, ${chartElement.clientWidth / 2}px, ${chartElement.clientHeight}px, 0)`
        innerSlice.style.transform = `rotate(${cumulativePercentage * 3.6}deg)`
        innerSlice.style.backgroundColor = item.color

        slice.appendChild(innerSlice)
        chartElement.appendChild(slice)

        cumulativePercentage += item.percentage
      })

      // 添加中心空洞
      const hole = document.createElement('div')
      hole.style.position = 'absolute'
      hole.style.width = '60%'
      hole.style.height = '60%'
      hole.style.borderRadius = '50%'
      hole.style.top = '20%'
      hole.style.left = '20%'
      hole.style.backgroundColor = 'white'

      chartElement.appendChild(hole)
    },
    seeMoreNames () {
      // 导航到名字列表页面
      this.$router.push('/names');
    },
    seeMoreGender () {
      // 导航到性别分类页面
      this.$router.push('/categories/gender');
    },
    seeMoreStyles () {
      // 导航到风格分类页面
      this.$router.push('/categories/style');
    },
    seeMoreSyllables () {
      // 导航到音节分类页面
      this.$router.push('/categories/syllables');
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.home-data {
	padding: rem(60) 0;
	display: flex;
	flex-direction: column;
	gap: rem(24);
	align-items: flex-start;
	justify-content: flex-start;
	position: relative;

	.data-header {
		padding: 0 rem(180);
		display: flex;
		flex-direction: row;
		gap: rem(16);
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		position: relative;

		.data-dot {
			background: #a31984;
			border-radius: rem(100);
			width: rem(8);
			height: rem(4);
			position: relative;
		}

		.data-title {
			color: #03133a;
			font-size: rem(28);
			line-height: rem(28);
			font-weight: 900;
			position: relative;
		}
	}

	.data-cards {
		padding: 0 rem(180);
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		// width: rem(1440);
		width: 100%;
		gap: rem(24);
		flex-wrap: wrap;

		position: relative;

		.data-card {
			background: linear-gradient(103.63deg, rgba(163, 25, 132, 1) 0%, rgba(163, 25, 132, 0.8) 100%);
			border-radius: rem(36);
			border: rem(1) solid #a31984;
			padding: rem(32) rem(40);
			display: flex;
			flex-direction: column;
			gap: rem(16);
			position: relative;
			box-shadow: 0 rem(2) rem(4) rgba(0, 0, 0, 0.08);
			width: 100%;
			flex-basis: calc(50% - rem(12));

			&.total-names {
				align-items: flex-start;
				justify-content: space-between;
				// width: rem(528);
				height: rem(260);
			}

			&.gender-ratio,
			&.style-distribution,
			&.syllable-distribution {
				align-items: flex-start;
				justify-content: flex-start;
				// width: rem(528);
				background: linear-gradient(103.63deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0.9) 100%);
				border: rem(1) solid rgba(3, 19, 58, 0.04);
				height: rem(260);
				padding: rem(32) rem(32) rem(24);
			}
			&.syllable-distribution {
				gap: rem(20);
			}

			.card-header,
			.card-footer {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: space-between;
				align-self: stretch;
				position: relative;

				.card-title {
					color: #03133a;
					font-size: rem(18);
					line-height: rem(20);
					font-weight: 900;
					position: relative;
					&.light {
						color: #ffffff;
					}

					.gender-ratio &,
					.style-distribution &,
					.syllable-distribution & {
						color: #03133a;
					}
				}

				.see-more {
					border-radius: rem(12);
					display: flex;
					flex-direction: row;
					gap: rem(8);
					align-items: center;
					justify-content: flex-start;
					cursor: pointer;

					span {
						color: #a31984;
						font-size: rem(12);
						line-height: rem(12);
						font-weight: 700;

						.gender-ratio &,
						.style-distribution &,
						.syllable-distribution & {
							color: #a31984;
						}
						&.light {
							color: #ffffff;
						}
					}

					img {
						width: rem(6);
						height: rem(10);
					}

					&:hover {
						opacity: 0.8;
					}
				}
			}

			.card-description {
				color: #ffffff;
				font-size: rem(12);
				line-height: rem(12);
				font-weight: 400;
				font-style: italic;
				position: relative;
			}

			.card-footer {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: space-between;
				align-self: stretch;
				position: relative;

				.footer-text {
					color: #03133a;
					font-size: rem(12);
					line-height: rem(12);
					font-weight: 400;
					font-style: italic;
					position: relative;
				}
			}

			.number-counter {
				display: flex;
				flex-direction: row;
				gap: rem(8);
				align-items: center;
				justify-content: space-between;
				align-self: stretch;
				position: relative;

				.digit-container {
					flex-basis: calc(20% - rem(8));
					flex-shrink: 0;
					// width: rem(82.8);
					height: rem(122);
					position: relative;

					.digit-flipper {
						display: flex;
						flex-direction: column;
						gap: rem(2);
						align-items: flex-start;
						justify-content: flex-start;
						width: 100%;
						position: relative;

						.digit-top {
							background: #ffffff;
							border-radius: rem(20) rem(20) 0 0;
							align-self: stretch;
							height: rem(60);
							position: relative;
						}

						.digit-bottom {
							background: #ffffff;
							border-radius: 0 0 rem(20) rem(20);
							opacity: 0.8;
							align-self: stretch;
							height: rem(60);
							position: relative;
						}

						.digit-number {
							color: #a31984;
							text-align: center;
							font-size: rem(80);
							line-height: rem(80);
							font-weight: 500;
							position: absolute;
							left: 50%;
							top: 50%;
							transform: translate(-50%, -50%);
						}
					}
				}
			}

			.gender-content {
				display: flex;
				flex-direction: row;
				align-items: flex-start;
				justify-content: space-between;
				align-self: stretch;
				position: relative;

				.gender-legend {
					padding: 0 rem(8);
					display: flex;
					flex-direction: column;
					gap: rem(20);
					align-items: flex-start;
					justify-content: flex-start;
					position: relative;

					.legend-item {
						display: flex;
						flex-direction: row;
						gap: rem(8);
						align-items: center;
						justify-content: flex-start;
						position: relative;

						.legend-color {
							background: #ffffff;
							border-radius: 50%;
							border: rem(4) solid;
							width: rem(12);
							height: rem(12);
							position: relative;

							&.boy {
								border-color: #38abff;
							}

							&.girl {
								border-color: #e54cba;
							}

							&.unisex {
								border-color: #10ad2f;
							}
						}

						.legend-text {
							color: #03133a;
							font-size: rem(14);
							line-height: rem(14);
							font-weight: 400;
							position: relative;
						}
					}
				}

				.gender-chart {
					padding: 0;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					height: rem(160);
					width: rem(200);
					position: relative;
				}
			}

			.style-chart {
				padding: rem(8) 0 0 0;
				display: flex;
				flex-direction: row;
				align-items: flex-end;
				justify-content: space-around;
				align-self: stretch;
				height: rem(160);
				position: relative;

				.style-item {
					display: flex;
					flex-direction: row;
					gap: rem(2);
					align-items: flex-end;
					justify-content: flex-start;
					flex-shrink: 0;
					position: relative;
					height: 100%;

					.style-bar {
						background: #a31984;
						border-radius: rem(100);
						flex-shrink: 0;
						width: rem(6);
						position: relative;
					}

					.style-label {
						width: rem(15);
						color: #374674;
						text-align: left;
						font-size: rem(12);
						line-height: rem(12);
						font-weight: 300;
						position: relative;
						// transform-origin: 0 0;
						transform-origin: rem(6) rem(5);
						transform: rotate(-90deg) scale(1, 1);
					}
				}
			}

			.syllable-chart {
				display: flex;
				flex-direction: column;
				gap: rem(20);
				align-items: flex-start;
				justify-content: flex-start;
				align-self: stretch;
				position: relative;

				.syllable-row {
					display: flex;
					flex-direction: row;
					gap: rem(16);
					align-items: center;
					justify-content: flex-start;
					align-self: stretch;
					position: relative;

					.syllable-bar-container {
						flex: 1;
						height: rem(12);
						position: relative;
						overflow: hidden;

						.syllable-bar {
							background: linear-gradient(90deg, rgba(163, 25, 132, 0.2) 0%, rgba(163, 25, 132, 0.4) 100%);
							height: 100%;
							transition: width 0.5s ease;
							position: relative;
							&::after {
								content: '';
								position: absolute;
								top: 0;
								right: 0;
								width: rem(4);
								height: rem(12);
								background: #a31984;
							}
						}
					}
				}
			}
		}
		.syllable-label {
			color: #03133a;
			font-size: rem(14);
			line-height: rem(16);
			font-weight: 400;
			width: rem(96);
			position: relative;
		}
	}

	.detect_deviece_mobile & {
		padding: rem(60) 0;
		.data-header {
			padding: 0 rem(16);
		}

		.data-cards {
			padding: 0 rem(16);
			flex-direction: column;
			width: 100%;
			gap: rem(16);

			.data-card {
				width: 100%;
				height: auto;

				&.total-names {
					gap: rem(20);
					.number-counter {
						.digit-container {
							flex: 1;
							height: rem(82);
							.digit-flipper {
								.digit-number {
									font-size: rem(50);
									line-height: rem(50);
								}
							}
						}
					}
				}

				&.gender-ratio {
					.gender-content {
						align-items: center;
						.gender-chart {
							width: rem(200);
							height: rem(160);
						}
					}
				}

				.gender-chart {
					order: 1;
				}
				.gender-legend {
					order: 2;
				}

				&.style-distribution,
				&.syllable-distribution {
					height: auto;
				}
			}
		}

		.syllable-label {
			width: rem(60) !important;
			color: #374674;
			font-size: rem(12);
			font-style: normal;
			font-weight: 300;
			line-height: rem(12); /* 100% */
			text-transform: capitalize;
		}

		.style-item {
			height: 100%;
		}

		.digit-top {
			height: rem(40) !important;
		}

		.digit-bottom {
			height: rem(40) !important;
		}
		.see-more {
			flex-shrink: 0;
		}
	}
}
</style> 